const normalizeLabel = (value) =>
    typeof value === "string" ? value.trim().toLowerCase() : "";

export const isDueTodayLabel = (value) =>
    normalizeLabel(value).includes("due today");

export const getDueTodayTextClass = ({
    surface = "light",
    interactive = false,
} = {}) => {
    const baseClass = surface === "warning" ? "text-red-500" : "text-red-700";

    if (!interactive) {
        return baseClass;
    }

    return `${baseClass} underline-offset-2 transition-colors ${
        surface === "warning" ? "hover:text-red-950" : "hover:text-red-800"
    }`;
};
